import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Reducers from 'types/Reducers';
import { getQuizGroupWithQuizzes } from './quizGroupAsync';

interface IState {
  data: { quizGroup: any; quizzes: any[] } | null;
  loading: boolean;
}

const initialState: IState = {
  data: null,
  loading: false,
};

const slice = createSlice({
  name: Reducers.QuizGroup,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getQuizGroupWithQuizzes.pending, (state) => {
      state.loading = true;
      state.data = null;
    });
    builder.addCase(getQuizGroupWithQuizzes.fulfilled, (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.loading = false;
    });
    builder.addCase(getQuizGroupWithQuizzes.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default slice.reducer;
